<template>
  <TwoColumnQuizReviewLayout>
    <template #responses>
      <CategoriseItem
        v-for="(item, index) in response"
        :key="index"
        :item="item"
        :showCheckMarkIcon="true"
      />
    </template>
    <template #answers>
      <CategoriseItem
        v-for="(item, index) in correctAnswers"
        :key="index"
        :item="item"
      />
    </template>
  </TwoColumnQuizReviewLayout>
</template>

<script>
import TwoColumnQuizReviewLayout from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReviewLayout.vue'
import CategoriseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/CategoriseItem.vue'

export default {
  name: 'Categorise',
  components: {
    TwoColumnQuizReviewLayout,
    CategoriseItem,
  },
  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    correctAnswers() {
      const answers = this.report?.answers
      return Array.isArray(answers) ? answers : []
    },
    response() {
      const responses = this.report?.response
      return Array.isArray(responses) ? responses : []
    },
  },
}
</script>
